import MinusSquared from './MinusSquared'

export default MinusSquared
// eslint-disable-next-line import/export
export * from './MinusSquared'
